import React from "react";
import PasswordResetForm from "./PasswordResetForm";

const PasswordReset = () => (
  <div style={{
    display:"grid",
    justifyContent:"center",
    padding:"5%"
  }} className="text-center">
    
    <PasswordResetForm />
  </div>
);

export default PasswordReset;
